import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { CheckboxListComponent } from "@components/checkbox-list/checkbox-list.component";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { Observable, of } from "rxjs";
import { ITplArbetsorder, ITplHandelssortiment } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplHandelssortimentFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-vaglager-filter",
    templateUrl: "./tpl-vaglager-filter.component.html",
    styleUrls: ["./tpl-vaglager-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        CheckboxListComponent
    ]
})
export class TplVaglagerFilterComponent extends FilterBaseComponent implements OnInit, ITplHandelssortimentFilter {

    @Input() dataSource: ITplArbetsorder[];

    options: Observable<string[]>;

    constructor() {
        super("vaglager");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));
        this.initOptions();
    }

    onFilterInit(state: string[]): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    match(item: ITplHandelssortiment): boolean {
        const value = this.value();
        const requireVaglager = value.some(x => x === "Ja");
        const excludeVaglager = value.some(x => x === "Nej");

        if (requireVaglager && excludeVaglager) {
            // Ja och Nej..? Blir "match".
            return true;
        }

        const hasVaglager = item.vagVolym > 0;
        if (requireVaglager) {
            return hasVaglager;
        }
        if (excludeVaglager) {
            return !hasVaglager;
        }
        return false;
    }

    value(): string[] {
        return this.control.value;
    }

    isActive(): boolean {
        return this.value()?.length > 0;
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addHandelssortimentFilter(this.name, this);
    }

    protected onFormChange(value: string[]): void {
        this.filterLength = !value ? 0 : value.length;
    }

    private initOptions(): void {
        const options = [
            "Ja",
            "Nej"
        ];
        this.options = of(options);
    }
}
